import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ClienteFichaResumoJanelaRoutingModule } from './cliente-ficha-resumo-janela-routing.module';
import { ClienteFichaResumoJanelaComponent } from './cliente-ficha-resumo-janela.component';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { MessagesModule } from 'primeng/messages';
import { InputMaskModule } from 'primeng/inputmask';
import { DividerModule } from 'primeng/divider';
import { CardModule } from 'primeng/card';
import { AccordionModule } from 'primeng/accordion';
import { BadgeModule } from 'primeng/badge';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import { InputSwitchModule } from 'primeng/inputswitch';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { BlockUIModule } from 'primeng/blockui';
import { PanelModule } from 'primeng/panel';
import { InputNumberModule } from 'primeng/inputnumber';
import { CalendarModule } from 'primeng/calendar';
import { ConfirmationService } from 'primeng/api';


@NgModule({
  declarations: [
    ClienteFichaResumoJanelaComponent
  ],
  imports: [
    CommonModule,
    ClienteFichaResumoJanelaRoutingModule,
    FormsModule,
    TableModule,
        InputTextModule,
        ButtonModule,
        MessagesModule,
        InputMaskModule,
        DividerModule,
        CardModule,
        AccordionModule,
        BadgeModule,
        TooltipModule,
        DialogModule,
        InputSwitchModule,
        DropdownModule,
        InputTextareaModule,
        ProgressSpinnerModule,
        ConfirmDialogModule,
        CheckboxModule,
        RadioButtonModule,
        BlockUIModule,
        PanelModule,
        InputNumberModule,
        CalendarModule
  ],
  providers: [ConfirmationService]
})
export class ClienteFichaResumoJanelaModule { }
